/**
 * Import public APIs for core services.
 * @module core
 */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomHttpService } from '../core/custom-http.service';
import { BlobErrorHttpService } from '../core/blob-error-http.service';
import { APIThrottleInterceptor } from '../core/api-throttle-interceptor';

export * from './my-breadcrumb.service';
export * from './facilities/facilities.service';
export * from './filter/chart-filter.service';
export * from './resident/residents.service';
export * from './user/user';
export * from './user/user.service';
export * from './window.service';

export const interceptors = [
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: APIThrottleInterceptor, multi: true }
];
